<template>
  <div id="login">
    <div class="col1">
      <h1>HDA Demo</h1>
      <p>
        Welcome to the HDA demo
      </p>
    </div>
    <div class="col2">
      <form v-if="showLoginForm" @submit.prevent>
        <h1>Login</h1>

        <label for="email1">Email</label>
        <input
          v-model.trim="loginForm.email"
          type="text"
          placeholder="you@email.com"
          id="email1"
        />

        <label for="password1">Password</label>
        <input
          v-model.trim="loginForm.password"
          type="password"
          placeholder="******"
          id="password1"
        />

        <button class="button" @click="login">Log In</button>

        <div class="extras">
          <a @click="togglePasswordReset">Forgot Password</a>
        </div>
      </form>
      <form v-if="showForgotPassword" @submit.prevent class="password-reset">
        <div v-if="!passwordResetSuccess">
          <h1>Reset Password</h1>
          <p>We will send you an email to reset your password</p>

          <label for="email3">Email</label>
          <input
            v-model.trim="passwordForm.email"
            type="text"
            placeholder="you@email.com"
            id="email3"
          />

          <button @click="resetPassword" class="button">Submit</button>

          <div class="extras">
            <a @click="togglePasswordReset">Back to Log In</a>
          </div>
        </div>
        <div v-else>
          <h1>Email Sent</h1>
          <p>check your email for a link to reset your password</p>
          <button @click="togglePasswordReset" class="button">
            Back to login
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { auth } from '../firebaseConfig.js'
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth'
import { useAppStore } from '@/stores/app'

export default {
  name: 'Login',
  setup() {
    const store = useAppStore()
    return { store }
  },
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      signupForm: {
        name: '',
        title: '',
        email: '',
        password: ''
      },
      passwordForm: {
        email: ''
      },
      showLoginForm: true,
      showForgotPassword: false,
      passwordResetSuccess: false
    }
  },
  methods: {
    async login() {
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          this.loginForm.email,
          this.loginForm.password
        )
        this.store.setCurrentUser(userCredential.user)
        this.$router.push('/')
      } catch (err) {
        console.error('Login error:', err)
      }
    },
    togglePasswordReset() {
      if (this.showForgotPassword) {
        this.showLoginForm = true
        this.showForgotPassword = false
        this.passwordResetSuccess = false
      } else {
        this.showLoginForm = false
        this.showForgotPassword = true
      }
    },
    async resetPassword() {
      this.performingRequest = true
      try {
        await sendPasswordResetEmail(auth, this.passwordForm.email)
        this.performingRequest = false
        this.passwordResetSuccess = true
        this.passwordForm.email = ''
      } catch (err) {
        this.performingRequest = false
        this.errorMsg = err.message
      }
    }
  }
}
</script>

<style scoped>
#login {
  height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
}
.col1 {
  display: block;
  flex: 1 1 0;
  padding-top: 33vh;
  padding-bottom: 33vh;
  background-color: rgb(120, 189, 184);
  color: white;
}
.col2 {
  display: block;
  height: auto;
  color: rgb(32, 81, 76);
  flex: 1 1 0;
  padding: 1rem;
  padding-top: 33vh;
  padding-bottom: 33vh;
}
form {
  display: block;
  margin: 0;
  text-align: left;
}
label {
  display: block;
}
input {
  display: block;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 3px;
  outline: 0;
  border: 1px solid #e6ecf0;
  margin: 0;
  margin-bottom: 1rem;
  font-size: 16px;
  width: 100%;
}
button {
  display: block;
  float: left;
}
.extras {
  float: right;
  text-align: right;
  display: block;
}
.extras * {
  display: block;
}
.button {
  background: rgb(32, 81, 76);
  border: 0;
  outline: 0;
  color: white;
  padding: 0.8rem 1rem;
  min-width: 150px;
  font-size: 16px;
  border-radius: 3px;
  cursor: pointer;
}
</style>
